var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"block font-semibold text-sm text-dark mb-1"},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.required)?_c('span',{staticClass:"text-primary"},[_vm._v("*")]):_vm._e()]),_vm._t("default"),(_vm.help)?_c('p',{staticClass:"text-xs text-dark opacity-60 mt-1"},[_vm._v(_vm._s(_vm.help))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }